import clickOutSide from './clickOutSide'
import * as inputFilter from './inputFilter'

const install = function(Vue) {
	Vue.directive('click-outside', clickOutSide)

	// 注册所有输入过滤指令
	Object.keys(inputFilter).forEach(key => {
		Vue.directive(key, inputFilter[key])
	})
}

export default install
